<template>
   <div>
    <Loading :displayDialog="showdialog" />
     <div class="election-data" v-for="(val,key) in data" :key="key">
                   <div class="election-name">{{ val.election }}</div>
                   <div class="text-center" v-if="val.time != ''">
                     <strong>Election Starts In</strong>
                  </div>
                  <div class="text-center" v-if="val.started == 1">
                     <strong>Election Ends In</strong>
                  </div>
                  <div class="text-center mt-3" v-if="val.time != ''">
                     <flip-countdown :deadline=val.time @timeElapsed="timeElapsedHandler(key)"></flip-countdown>
                  </div>
                  <div class="text-center mt-3" v-if="val.started == 1">
                    <flip-countdown :deadline=val.enddate  @timeElapsed="timeElapsedHandlerAnother(key)"></flip-countdown>
                 </div>
                  <div v-if="val.started == 1" class="text-center mt-3">
                    <v-btn class="mybtn"  color="primary" @click="vote(val.id)"><span>Vote</span></v-btn>
                    <!--<v-btn class="mybtn" v-else color="primary" to="/auth?action=login"><span>Vote</span></v-btn>-->
                  </div>
               </div> 

   <v-dialog
  v-model="identitiesdialog"
  max-width="320px"
  content-class="date-picker-dialog"
>
  <v-card>
    <v-toolbar color="primary" dark>
      <div v-if="!nototp">Confirm Your Identity</div>
      <div v-else>One Time Password</div>
    </v-toolbar>

    <v-card-text>
      <div class="mt-5" v-if="!nototp">
        <div v-for="(val,key) in identities" :key="key" class="mb-2">
          <v-text-field
            v-if="val.dob == 0 && val.address == 0"
            hide-details
            outlined
            :label="val.fieldname"
            v-model="criteria[val.fieldname]"
          />

          <div class="address-input-wrapper" v-if="val.address == 1">
            <v-text-field
              hide-details
              outlined
              v-model="criteria[val.fieldname]"
              @input="fetchAddresses(criteria[val.fieldname], val.fieldname)"
              :label="val.fieldname"
            />
            <ul v-if="addresses.length" class="address-list">
              <li
                v-for="(address, index) in addresses"
                :key="index"
                @click="selectAddress(address)"
                class="address-item"
              >
                {{ address }}
              </li>
            </ul>
          </div>

          <v-menu
            v-if="val.dob == 1"
            v-model="dateMenus[val.fieldname]"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                hide-details
                outlined
                :label="val.fieldname"
                v-model="displayDates[val.fieldname]"
                @input="handleDateInput(val.fieldname, $event)"
                @blur="validateAndFormatDate(val.fieldname)"
                placeholder="DD/MM/YYYY"
                v-bind="attrs"
                v-on="on"
                :error-messages="dateErrors[val.fieldname]"
                append-icon="mdi-calendar"
                @click:append="dateMenus[val.fieldname] = !dateMenus[val.fieldname]"
              />
            </template>
            <v-date-picker
              v-model="criteria[val.fieldname]"
              @input="handleDatePickerInput(val.fieldname, $event)"
              scrollable
              :max="new Date().toISOString().substr(0, 10)"
            />
          </v-menu>
        </div>

        <div class="errorlog">{{ identityError }}</div>
      </div>

      <div v-if="nototp">
        <otp @value-sent="handleValueFromChild" />
      </div>
    </v-card-text>

    <v-card-actions class="justify-space-between" v-if="!nototp">
      <v-btn color="red" class="white--text" @click="closedialog">Close</v-btn>
      <v-btn color="green" class="white--text" @click="confirmIdentity">Confirm</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

         
    <v-overlay :value="templatePopup" opacity="0.5">
      <v-dialog content-class="ballot" class="myballot" :absolute="true" :style="dialogTopStyle" v-model="templatePopup" persistent >
        <v-card>
         <v-card-text style="max-height: 600px; overflow-y: auto;">
          <div class="ballot-template">
           <Template1 v-if="template == 'template1'" @data-sent="handleChildData" :preview=true :votetype=voteType :previewdata=childdata :showresult=true :vote=true />
           <Template2 v-if="template == 'template2'" @data-sent="handleChildData" :preview=true :votetype=voteType :previewdata=childdata :showresult=true :vote=true  />
           <div class="makecontainer" v-if="showsuccessvote">
              <div class="success-vote">Thank you for voting with myvoco.</div>
              <div class="clarity">Would you like a confirmation email that you have voted for your records?</div>
              <div class="confirmit">
                <v-radio-group @change="checkVoter" v-model="needcertificate">
                  <v-radio label="Yes" value="Yes"></v-radio>
                  <v-radio label="No" value="No"></v-radio>
                </v-radio-group>
              </div> 
              <div v-if="showemailBlock" class="mb-5">
                <v-text-field hide-details outlined name="Email" label="email" v-model="emailaddress"></v-text-field>
                <div class="errorlog">{{ identityError }}</div>
              </div>
              <div class="text-center">
                <v-btn type="button" :disabled=disableButton @click="confirmMyCertificate" color="secondary">Confirm</v-btn>  
              </div>
           </div>
         </div>
      </v-card-text>
      <v-card-actions class="ballotaction" v-if="showconfirmVotebtn">
        <v-btn type="button" :disabled=disableButton @click="confirmMyVote" color="secondary">Confirm</v-btn>  
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-overlay>
   </div>      
</template>   
<script>
import CryptoJS from 'crypto-js';
import { encryptionKey } from '../../config';

import axios from 'axios';
import Otp from '../components/Otp.vue';
import FlipCountdown from 'vue2-flip-countdown';

import Template1 from '../Templates/Template1.vue';
import Template2 from '../Templates/Template2.vue';
import Loading from '../components/Loader.vue';

export default {
  props: {
    data: {
      type: Array,
      required: true
    }
  },  
  data() {
    return {
     identities:[],
     criteria:{},
     displayDates:{}, // New: for display formatting
     dateErrors:{},   // New: for validation errors
     identityError:'',
     identitiesdialog:false,
     templatePopup:false,
     showsuccessvote:false,
     template:'',
     showconfirmVotebtn:false,
     nototp: false,
     addresses: [],
     showdialog:false,
     electionid:0,
     dateMenus: {},
     childdata:[],
      voteType:'',
      showemailBlock:false,
      needcertificate:'',
      disableButton:false,
    };
  },
  components:{
      FlipCountdown,
      Template1, 
      Template2,
      otp: Otp,
      Loading,
  },
  computed: {
    dialogTopStyle() {
      // Define custom styles for top position
      return window.innerWidth <= 600 ? { top: '0' } : {};
    },
     loggedIn() {
      return this.$store.getters.loggedIn;
     },
  },
  methods: 
  { 
     confirmMyCertificate()
    {
       let error = 0;
       if(this.needcertificate == 'Yes' && this.emailaddress == '')
       {  
         this.showemailBlock = true;
         this.identityError = 'Please provide email';
         error = 1;
       }
       if(this.needcertificate == 'No')
       {
          this.makeAllReset();
       }
       
       if(error == 0 && this.needcertificate == 'Yes')
       {
          /*let formData = new FormData();
            formData.append('eid', this.electionid);
            formData.append('criteria', JSON.stringify(this.criteria));
            formData.append('email', this.emailaddress);*/
            const data = {
                criteria: JSON.stringify(this.criteria),
                eid: this.electionid,
                email: this.emailaddress
            }; 
        
          var encryptedData = this.encryptMe(data);
            this.disableButton = true;
            axios.post('/my-vote-certificate', { myData: encryptedData}).then(response => 
            {
              this.disableButton = false;
              if(response.data.status)
              {
                 this.makeAllReset();
              }
            }).catch(error => {
              console.log(error);
            });
       }
    },
      makeAllReset(){
      this.template = '';
      this.templatePopup = false;
      this.showsuccessvote = false;
      this.showemailBlock = false;  
      this.criteria = {};
      this.electionid = '';
      this.identityError = '';
      this.emailaddress = '';
      this.needcertificate = '';
    },
   
     handleChildData(data) {
       if(data.showconfirm == 1)
       {
         this.showconfirmVotebtn = true;
         this.voteData = data.vote;
       }
       else{
        this.showconfirmVotebtn = false;
       }
    },
    // New method: Handle manual date input with formatting
    handleDateInput(fieldname, event) {
      let value = event.target.value;
      // Remove all non-numeric characters
      let cleaned = value.replace(/\D/g, '');
      
      // Add slashes as user types
      if (cleaned.length >= 3) {
        cleaned = cleaned.substring(0, 2) + '/' + cleaned.substring(2);
      }
      if (cleaned.length >= 6) {
        cleaned = cleaned.substring(0, 5) + '/' + cleaned.substring(5, 9);
      }
      
      // Limit to 10 characters (DD/MM/YYYY)
      if (cleaned.length > 10) {
        cleaned = cleaned.substring(0, 10);
      }
      
      this.$set(this.displayDates, fieldname, cleaned);
      
      // Clear any existing errors while typing
      if (this.dateErrors[fieldname]) {
        this.$delete(this.dateErrors, fieldname);
      }
    },

    // New method: Handle date picker selection
    handleDatePickerInput(fieldname, value) {
      this.criteria[fieldname] = value;
      this.$set(this.displayDates, fieldname, this.formatDateDisplay(value));
      this.dateMenus[fieldname] = false;
      
      // Clear any errors
      if (this.dateErrors[fieldname]) {
        this.$delete(this.dateErrors, fieldname);
      }
    },

    // New method: Validate and format manually entered dates
    validateAndFormatDate(fieldname) {
      const value = this.displayDates[fieldname];
      if (!value || value.length === 0) {
        this.criteria[fieldname] = '';
        return;
      }

      // Check if it matches DD/MM/YYYY pattern
      const datePattern = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
      const match = value.match(datePattern);
      
      if (match) {
        const day = parseInt(match[1]);
        const month = parseInt(match[2]);
        const year = parseInt(match[3]);
        
        // Validate the date
        const date = new Date(year, month - 1, day);
        if (date.getDate() === day && date.getMonth() === month - 1 && date.getFullYear() === year) {
          // Format properly with leading zeros for display
          const formattedDisplay = `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
          this.$set(this.displayDates, fieldname, formattedDisplay);
          
          // Convert to YYYY-MM-DD format for v-date-picker
          const formattedValue = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
          this.criteria[fieldname] = formattedValue;
          
          // Clear any errors
          this.$delete(this.dateErrors, fieldname);
        } else {
          this.$set(this.dateErrors, fieldname, 'Invalid date');
        }
      } else {
        this.$set(this.dateErrors, fieldname, 'Please use DD/MM/YYYY format');
      }
    },

    formatDateDisplay(date) {
      if (!date) return '';
      // Convert YYYY-MM-DD to DD/MM/YYYY for display
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },

     encryptMe(data){
      let iv = CryptoJS.lib.WordArray.random(16);
      let key = CryptoJS.enc.Base64.parse(encryptionKey);
      let options = {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
      };
      let encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), key, options);

      encrypted = encrypted.toString();
      iv = CryptoJS.enc.Base64.stringify(iv);
      let result = {
            iv: iv,
            value: encrypted,
            mac: CryptoJS.HmacSHA256(iv + encrypted, key).toString()
        }
      result = JSON.stringify(result);
      result = CryptoJS.enc.Utf8.parse(result);
      let encryptedData = CryptoJS.enc.Base64.stringify(result);
      
      return encryptedData;
    },
      decryptMe(encryptStr)
      {
        
        let encryptStrVal = CryptoJS.enc.Base64.parse(encryptStr);
        let encryptData = encryptStrVal.toString(CryptoJS.enc.Utf8);
            encryptData = JSON.parse(encryptData);
        let iv = CryptoJS.enc.Base64.parse(encryptData.iv);
        var decrypted = CryptoJS.AES.decrypt(encryptData.value,  CryptoJS.enc.Base64.parse(encryptionKey), {
            iv : iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        decrypted = CryptoJS.enc.Utf8.stringify(decrypted); 
      
        return decrypted;
      },
     fetchAddresses(query, fieldname) 
      {
         if (!query || query.length < 2) 
         {
           this.addresses = []; // Clear suggestions if query is too short
           return;
         }
         this.currentField = fieldname;
         const data = 
         {
              criteria: JSON.stringify(query),
              eid: this.electionid,
         };
         var encryptedData = this.encryptMe(data);
         axios.post('/getaddress', { data: encryptedData })
        .then(response => {
          this.addresses = response.data;
        })
        .catch(error => {
          console.error("Error fetching addresses:", error);
        });
     },
     selectAddress(address) 
     {
       if (this.currentField) {
         this.criteria[this.currentField] = address; // Fill the correct input field
         this.addresses = []; // Hide the dropdown after selection
         this.currentField = null; // Reset after selection
       }
     },
     handleValueFromChild(value) 
     {
       if(value == "correct")
       {
          this.identitiesdialog = false;    
          this.templatePopup    = true;
          this.nototp = false;
       }
     },
     vote(id)
     {
        this.showdialog = true;
        this.electionid = id;
        this.$store.dispatch("getElectionFields",{eid:id}).then((response) => 
        {
          this.showdialog = false;
          if(response.status)
          {
            this.identitiesdialog = true;    
            // this.identities = response.data;
            let encryptStr =  response.data;
            let decrypted = this.decryptMe(encryptStr);
            let finalresult = this.unserializePhpArray(decrypted);
            this.identities = finalresult;

            this.identities.forEach(item => {
      if (item.dob === 0 && item.address === 0) {
        // Set default value if present, otherwise empty string
        this.$set(this.criteria, item.fieldname, item.value || '');
      } else {
        // Ensure reactive property exists even if blank for other fields
        this.$set(this.criteria, item.fieldname, '');
      }
    });
          }
        });
     },
      unserializePhpArray(serializedString) 
    {
      try {
        const start = serializedString.indexOf(':"');
        const jsonString = serializedString.substring(start + 2, serializedString.length - 2);
        const result = JSON.parse(jsonString);
        
        return result;
      } catch (error) 
      {
        console.error("Error deserializing PHP array:", error);
        return {}; // Return an empty object in case of error
       }
    },
     async confirmMyVote()
    {
      const data = {
                criteria: JSON.stringify(this.criteria),
                eid: this.electionid,
                vote: JSON.stringify(this.voteData),
                voter: this.voter,
                pole: this.pole
            }; 
        
          var encryptedData = this.encryptMe(data);
          this.disableButton = true;
          axios.post('/do-my-vote', { myData: encryptedData}).then(response => 
          {
            this.disableButton = false;
            if(response.data.status)
            {
               this.showconfirmVotebtn = false;
               this.showsuccessvote = true;
               this.template = '';
            }
          }).catch(error => {
            console.log(error);
          });
     },
     closedialog() {
      this.identitiesdialog = false;
     },
     confirmIdentity()
    {
       var checkError = 0;
       this.identityError = '';
       
       // Check for date validation errors first
       for (const fieldname in this.dateErrors) {
         if (this.dateErrors[fieldname]) {
           checkError = 1;
           this.identityError = 'Please fix date format errors';
           break;
         }
       }
       
       if (checkError === 0) {
         for(var i = 0; i < this.identities.length; i++)
         {
           if(typeof this.criteria[this.identities[i]['fieldname']] == 'undefined')
           {
             checkError = 1;
           }
           else
           {
              if(this.criteria[this.identities[i]['fieldname']].trim() == '')
             {
              checkError = 1;
             }
           }
         }
         if(checkError == 1)
         {
           this.identityError = 'All fields are mandatory';
         }
       }
       
       if(checkError == 0)
       {
          // Prepare the data to be encrypted
          const data = {
                criteria: JSON.stringify(this.criteria),
                eid: this.electionid
            }; 
          this.disableButton = true;
          var encryptedData = this.encryptMe(data);
          axios.post('/search-my-vote',{ myData: encryptedData}).then(response => 
          {
             this.disableButton = false;
             if(response.data.status)
             {
                this.identityError    = '';
                this.nototp = true;
                let encryptStr        = response.data.data;
                let decrypted         = this.decryptMe(encryptStr);
                let finalresult       = this.unserializePhpArray(decrypted);
                
                if(finalresult.template != '')
                {
                    this.voter                   = finalresult.voter;
                    this.template                = finalresult.template;
                    this.childdata['color']      = finalresult.template_data.color;
                    this.childdata['data']       = finalresult.template_data.data;
                    this.childdata['note']       = finalresult.template_data.note;
                    this.childdata['candidates'] = finalresult.candidates;
                    this.voteType                = finalresult.votetype;
                    this.childdata['numberTo']   = finalresult.numberTo; 
                    this.pole                    = finalresult.pole;
                }
              }
              else
              {
                  this.identityError = response.data.msg;
              }
            }).catch(error => {
                console.log(error);
                this.disableButton = false;
                this.makeitdisable = false;
            })   
       }
     },
     checkVoter()
    {
      if(this.needcertificate == 'Yes')
       {  
         this.showemailBlock = true;
       }
      else
       {
         this.showemailBlock = false;  
         //this.makeAllReset();
       }  
     },
  },
};
</script>
<style scoped>
.election-data{min-height: 65px; padding: 15px; margin-top: 15px; border-radius: 8px; box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;}
.election-name { margin-bottom: 5px; font-size: 19px;}
.overlaycustom{position: fixed;top: 0;left: 0;width: 100%;height: 100%;background-color: rgba(0, 0, 0, 0.8);display: flex;align-items: center;justify-content: center;z-index: 1000;}
.dialogcustom {background-color: white;border-radius: 8px;text-align: left;position: relative;top: 40%;left: 50%;transform: translate(-50%, -50%);width: 350px;max-width: 80%;box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); padding: 0;}
.errorlog{color: red; font-size: 14px;}
.address-input-wrapper {position: relative;width: 100%;}
.address-list {list-style-type: none;margin: 0;padding: 0;background-color: #fff;border: 1px solid #ddd;border-radius: 4px;max-height: 200px;overflow-y: auto; position: absolute;width: 100%;z-index: 1000;top: calc(100% + 5px);left: 0;box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);}
.address-item {padding: 10px;cursor: pointer;font-size: 14px;transition: background-color 0.3s ease;}
.address-item:hover {background-color: #f0f0f0;}
.address-item:active { background-color: #e0e0e0;}
.address-item:not(:last-child) {border-bottom: 1px solid #eee;}
.makecontainer {background: white;padding: 10px 10px;color: black;}
.success-vote {text-align: center;margin-top: 10px; margin-bottom: 15px; font-size: 18px;}
</style>
<style>
.date-picker-dialog {
  overflow: visible !important;
}

.date-picker-dialog .v-card {
  overflow: visible !important;
}
.date-picker-dialog .v-card__text{
  padding: 15px !important;
}
</style>